export const  RELATION_OPERATIONS = [
  {
      "id": 1,
      "code": ">",
      "name": ">",
      "direction": 0,
      "symmetry": {
          "id": 4,
          "code": "<=",
          "name": "<=",
          "direction": 1,
          "symmetry": null,
          "weight": 3
      },
      "weight": 0
  },
  {
      "id": 2,
      "code": "<",
      "name": "<",
      "direction": 1,
      "symmetry": {
          "id": 3,
          "code": ">=",
          "name": ">=",
          "direction": 0,
          "symmetry": null,
          "weight": 2
      },
      "weight": 1
  },
  {
      "id": 3,
      "code": ">=",
      "name": ">=",
      "direction": 0,
      "symmetry": {
          "id": 2,
          "code": "<",
          "name": "<",
          "direction": 1,
          "symmetry": null,
          "weight": 1
      },
      "weight": 2
  },
  {
      "id": 4,
      "code": "<=",
      "name": "<=",
      "direction": 1,
      "symmetry": {
          "id": 1,
          "code": ">",
          "name": ">",
          "direction": 0,
          "symmetry": null,
          "weight": 0
      },
      "weight": 3
  }
]